export class GroupedCheck {
  constructor(
    public hash: string,
    public date: number,
    public time: number,
    public firstname: string,
    public lastname: string
  ) { }

  get fullname() {
    return `${this.firstname} ${this.lastname}`;
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/models/grouped-check.ts